/**
 * IMPORTS
 */

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Undo2 } from "lucide-react";

// componentes
import { Button } from "@components/button/button";
import { Spinner } from "@components/spinner/spinner";
import { Tabs, TabsList, TabsTrigger } from "@components/tabs";
import { VisualizacaoModeloTecnico } from "@components/visualizacao-modelo";

// hooks / react-query
import { useBuscarModeloUnicoPorCliente } from "@/hooks/modelos/buscar-modelo-unico-por-cliente";

// hooks / zustand
import { useStoreZustandPegarTarefas } from "@/store-zustand/admin/pegar-tarefas";

const VisualizarModelo = () => {
  const navigate = useNavigate();

  const handleVoltar = useCallback(() => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  }, [navigate]);

  const { tarefa } = useStoreZustandPegarTarefas();

  const modeloId = tarefa?.modelo_id ?? 0;

  const { modeloUnico, isLoading } = useBuscarModeloUnicoPorCliente(modeloId!);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <Tabs defaultValue="all">
          <div className="flex items-center">
            <TabsList>
              <TabsTrigger value="all">Modelo cliente</TabsTrigger>
            </TabsList>
            <div className="mb-4 ml-auto mr-4 flex items-center gap-2">
              <Button
                size="sm"
                variant="default"
                className="h-8 gap-1 text-neutral-50"
                onClick={handleVoltar}
              >
                <Undo2 className="h-3.5 w-3.5" />
                <span className="sm:whitespace-nowra sr-only text-neutral-50 sm:not-sr-only">
                  Voltar
                </span>
              </Button>
            </div>
          </div>
          <div className="mx-auto w-full rounded-lg bg-white p-6 shadow-md dark:bg-white">
            <h2 className="dark:text-gray text-xl font-semibold text-gray-800">
              Veja com detalhe o modelo do cliente
            </h2>
            <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
              confirme as informações pessoais do modelo.
            </p>
            <VisualizacaoModeloTecnico modelo={modeloUnico as any} />
          </div>
        </Tabs>
      )}
    </>
  );
};

/**
 * EXPORT
 */
export { VisualizarModelo };
